module.exports = __webpack_public_path__ + "b55668fb613d7f1db188d7a3f6288968.png";